import { render, staticRenderFns } from "./BaseFormatDateField.vue?vue&type=template&id=2b823542"
import script from "./BaseFormatDateField.vue?vue&type=script&lang=js"
export * from "./BaseFormatDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports